import { FilterParams } from "interfaces/filters";
import { PaginationParams } from "interfaces/pagination";
import { IResponseGetChecklistUser, IHubChecklistUser } from "interfaces/Hub";
import { applyQueryString } from "lib/queryString";
import { apiGeneral } from "services";

export function useHubChecklistUser() {
  const getListChecklistUsers = async (
    filters: FilterParams,
    pagination: PaginationParams
  ): Promise<any> => {
    const url = applyQueryString(`/checklist-user`, {
      ...filters,
      ...pagination,
    });
    const { data } = await apiGeneral.get<IResponseGetChecklistUser>(url);
    return data;
  };

  const createChecklistUser = async (
    data: Partial<IHubChecklistUser>
  ): Promise<void> => {
    await apiGeneral.post("/checklist-user", data);
  };

  const getChecklistUser = async (id: string): Promise<IHubChecklistUser> => {
    const { data } = await apiGeneral.get(`/checklist-user/${id}`);
    return data;
  };
  
  const updateChecklistUser = async (
    data: Partial<IHubChecklistUser>
  ): Promise<void> => {
    await apiGeneral.put(`/checklist-user/${data.id}`, data);
  };

  const deleteChecklistUser = async (id: number): Promise<void> => {
    await apiGeneral.delete(`/checklist-user/${id}`);
  };

  return {
    getListChecklistUsers,
    createChecklistUser,
    updateChecklistUser,
    deleteChecklistUser,
    getChecklistUser,
  };
}
